import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function AdminEmptyState({ message, icon: Icon }) {
  return (
    <Box sx={{ py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      {Icon && (
        <Box sx={{ color: 'text.disabled' }}>
          <Icon size={48} />
        </Box>
      )}
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}
